import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Trigger Trace.
 *
 *   Overview    is anyone using it, and do they close what they open
 *   Patterns    what sets people off, where in life it comes from, how hard
 *   Resolution  the closing act — how much is worked through, and how fast
 *   Employees   who is using the tool, and how much
 *
 * The Employees tab is engagement only, and there is no page behind a row. It
 * answers "is the benefit being taken up" and nothing else: no trigger, no
 * emotion, no life area, no intensity ever appears beside a name. What somebody
 * logs is theirs; that they logged something is the company's to count.
 *
 * The two free-text fields a trigger log carries — the private notes somebody
 * writes about what happened — are not read by anything in this section.
 */
const CompanyTriggerLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';
  const base = `/${slug}/trigger-trace`;

  const pages = [
    {
      label: 'Overview',
      path: base,
      description: 'Take-up, and whether people get past what they log'
    },
    {
      label: 'Patterns',
      path: `${base}/patterns`,
      description: 'What sets people off, which parts of life it comes from, and how hard it lands'
    },
    {
      label: 'Resolution',
      path: `${base}/resolution`,
      description: 'How much gets worked through, how long it takes, and what is still open'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `${base}/users`,
      description: 'Who is using the tool and how much — never what they logged'
    }
  ];

  return (
    <CompanySectionLayout
      title="Trigger Trace"
      subtitle={`How your ${population} use Trigger Trace to name what set them off and work through it. Aggregate figures only — what anybody wrote is never read, no trigger is ever shown beside a name, and groups too small to anonymise are not reported at all.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyTriggerLayout;
